import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit'

import {Trade} from "@Redux/slices/trade/trades/types";
import { asyncLogout } from '@Redux/slices/user/UserSlice'

export const setTrades = createAsyncThunk<{trades: Trade[], accountId: string}, {trades: Trade[], accountId: string}>('user/setUserTrades', async (payload) => {
  return payload
})

interface TradesStateInterface {
  tradesList: { [accountId: string]: Trade[] }
  tradeToEdit: Trade | null
  isLoading: boolean,
  error: null | string,
}

const initialState: TradesStateInterface = {
  tradesList: {},
  tradeToEdit: null,
  isLoading: false,
  error: null,
}

export const TradesSlice = createSlice({
  name: 'trades',
  initialState,
  reducers: {
    setEditTrade: (state, action: PayloadAction<Trade>) => {
      state.tradeToEdit = action.payload
    },
    clearEditTrade: (state) => {
      state.tradeToEdit = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(setTrades.fulfilled, (state, {payload}) => {
        if (payload.accountId) {
          state.tradesList[payload.accountId] = payload.trades
          state.tradeToEdit = payload.trades.find((t) => t.id == state.tradeToEdit?.id) ?? null
        }
        state.isLoading = false
      })
      .addCase(asyncLogout.fulfilled, (state) => {
        state.tradesList = {}
        state.tradeToEdit = null
      })
  }
})

export const { setEditTrade, clearEditTrade } = TradesSlice.actions
export default TradesSlice.reducer